import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';

import { SelectorType } from '@fcom/booking-widget/interfaces';

@Component({
  selector: 'fin-booking-header-summary-item',
  templateUrl: './booking-header-summary-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BookingHeaderSummaryItemComponent {
  @Input() type: SelectorType;
  @Input() isClickable = false;
  @Input() customClasses: string;
  @Output() clickAction: EventEmitter<SelectorType> = new EventEmitter();
}
